import { CMSCTA } from "../../models"
import { NavigationType, NavigationTypes } from "../../types"

export const DEFAULT_FORMAT_DATE = sessionStorage?.getItem('format_date') || 'DD/MM/YYYY';
export const DEFAULT_FORMAT_DATE_FORM = 'DD/MM/YYYY';
export const DEFAULT_FORMAT_DATETIME_FORM = 'DD/MM/YYYY HH:mm';


export const array_move = <RecordType extends Record<string, unknown>>(
    inputArray: RecordType[],
    fromIndex: number,
    toIndex: number,
    indexToMove: string
) => {
    const array = [...inputArray];

    const element = array[fromIndex];
    array.splice(fromIndex, 1);
    array.splice(toIndex, 0, element);

    return array.map((el, idx) => ({
        ...el,
        [indexToMove]: idx + 1,
    }));
};

export const throttle = (fn: Function, delay: number = 100) => {
    let lastCall = 0;
    return (...args: any[]) => {
        if (Date.now() - lastCall >= delay) {
            lastCall = Date.now();
            return fn(...args);
        }
    };
};


export function getNavPathFromType(type: NavigationType | string, params?: CMSCTA['scopeParameters']) {
    switch (type) {
        case NavigationTypes.LOGIN:
            return `/login${params?.redirect ? `?redirect=${params?.redirect}` : ''}`
        case NavigationTypes.PUBLIC_HOME:
        case NavigationTypes.HOME:
            return '/public'
        case NavigationTypes.REGISTRATION:
            return '/registration'
        case NavigationTypes.FORGOT_PASSWORD:
            return '/forgotPassword'
        case NavigationTypes.PRIVATE_HOME:
            return '/'
        case NavigationTypes.EVENTS:
            return '/events'
        case NavigationTypes.CONTESTS:
            return '/contests'
        case NavigationTypes.HOW_TO:
            return '/howTo'
        case NavigationTypes.PUBLIC_HOW_TO:
            return '/public/howTo'
        case NavigationTypes.FAQ:
            return '/faq'
        case NavigationTypes.PUBLIC_FAQ:
            return '/public/faq'
        case NavigationTypes.CONTACTS:
            return '/contacts'
        case NavigationTypes.PROFILE:
            return '/profile'
        case NavigationTypes.FRIENDS:
            return '/friends'

        /** DEFAULT HISTORY REWARD IS CONTEST **/
        case NavigationTypes.HISTORY_REWARDS:
            return '/profile/rewardsHistory'
        case NavigationTypes.HISTORY_REWARDS_DETAILS:
            return `/profile/rewardsHistory/${params?.redemptionId}`
        /** ********************************* **/


        case NavigationTypes.HISTORY_REWARDS_CONTEST:
            return '/profile/rewardsHistory/contest'
        case NavigationTypes.HISTORY_REWARDS_CONTEST_DETAILS:
            return `/profile/rewardsHistory/contest/${params?.redemptionId}`
        case NavigationTypes.HISTORY_REWARDS_CATALOG:
            return '/profile/rewardsHistory/catalog'
        case NavigationTypes.HISTORY_REWARDS_CATALOG_LOYALTY_COLLECTION:
            return '/profile/rewardsHistory/catalog/loyaltyCollection'
        case NavigationTypes.HISTORY_REWARDS_CATALOG_DIGITAL_WALLET:
            return '/profile/rewardsHistory/catalog/digitalWallet'
        case NavigationTypes.HISTORY_REWARDS_CATALOG_DETAILS:
            return `/profile/rewardsHistory/catalog/${params?.redemptionId}`
        case NavigationTypes.HISTORY_REWARDS_CATALOG_LOYALTY_COLLECTION_DETAILS:
            return `/profile/rewardsHistory/catalog/loyaltyCollection/${params?.redemptionId}`
        case NavigationTypes.HISTORY_REWARDS_CATALOG_DIGITAL_WALLET_DETAILS:
            return `/profile/rewardsHistory/catalog/digitalWallet/${params?.redemptionId}`
        case NavigationTypes.HISTORY_CONTESTS:
            return '/profile/contestHistory'
        case NavigationTypes.HISTORY_CONTESTS_DETAILS:
            return `/profile/contestHistory/${params?.contestId}`
        case NavigationTypes.HISTORY_POINTS:
            return '/profile/pointsHistory'
        case NavigationTypes.LOGOUT:
            return '/logout'
        case NavigationTypes.REDEEM:
        case NavigationTypes.GO_TO_REDEMPTION:
            return `/redeem/${params?.redemptionId}`
        case NavigationTypes.CONTEST_DETAILS:
            return `/contest/${params?.contestLogicId}`
        case NavigationTypes.EVENT_DETAILS:
            return `/event/${params?.eventLogicId}`
        case NavigationTypes.CATALOG_DIGITAL_WALLET:
            return `/catalog/digital-wallet/${params?.initiativeLogicId}`
        case NavigationTypes.PUBLIC_CATALOG_DIGITAL_WALLET:
            return `/public/catalog/digital-wallet/${params?.initiativeLogicId}`
        case NavigationTypes.CATALOG_LOYALTY_COLLECTION:
            return `/catalog/loyalty-collection/${params?.initiativeLogicId}`
        case NavigationTypes.PUBLIC_CATALOG_LOYALTY_COLLECTION:
            return `/public/catalog/loyalty-collection/${params?.initiativeLogicId}`
        case NavigationTypes.CATALOG_DIGITAL_WALLET_DETAILS:
            return `/catalog/digital-wallet/${params?.initiativeLogicId}/${params?.productId}${params?.relatedId ? `/${params?.relatedId}` : ''}`
        case NavigationTypes.PUBLIC_CATALOG_DIGITAL_WALLET_DETAILS:
            return `/public/catalog/digital-wallet/${params?.initiativeLogicId}/${params?.productId}${params?.relatedId ? `/${params?.relatedId}` : ''}`
        case NavigationTypes.CATALOG_LOYALTY_COLLECTION_DETAILS:
            return `/catalog/loyalty-collection/${params?.initiativeLogicId}/${params?.productId}${params?.relatedId ? `/${params?.relatedId}` : ''}`
        case NavigationTypes.PUBLIC_CATALOG_LOYALTY_COLLECTION_DETAILS:
            return `/public/catalog/loyalty-collection/${params?.initiativeLogicId}/${params?.productId}${params?.relatedId ? `/${params?.relatedId}` : ''}`
        case NavigationTypes.EVENT_FORM:
            return `/event/${params?.eventLogicId}/extra/form`
        case NavigationTypes.CONTEST_EVENT_FORM:
            return `/contest/${params?.contestLogicId}/extra/form`
        case NavigationTypes.NO_AUTH:
            return `/noAuth`
        case NavigationTypes.MAINTENANCE:
            return `/maintenance`
        case NavigationTypes.NOT_FOUND:
            return `/404`
        case NavigationTypes.SSO_FINALIZE:
            return `/sso/finalize`
        case NavigationTypes.REGISTRATION_FINALIZE:
            return `/registration/finalize`
        case NavigationTypes.SERVER_ERROR:
            return `/serverError`
        case NavigationTypes.CHECKOUT:
            return `/checkout/${params?.initiativeLogicId}${params?.basketType ? `/${params?.basketType}` : ''}`
        case NavigationTypes.CART:
            return `/cart${params?.initiativeLogicId ? `/${params?.initiativeLogicId}` : ''}`
        case NavigationTypes.PUBLIC_AZIMUT_FONDI:
            return `/public/fondi`
        case NavigationTypes.PUBLIC_AZIMUT_ABOUT:
            return `/public/about`
        case NavigationTypes.AZIMUT_FONDI:
            return  `/fondi`
        case NavigationTypes.AZIMUT_ABOUT:
            return `/about`
        case NavigationTypes.VAS:
            return `/vas`
        case NavigationTypes.PUBLIC_VAS:
            return `/public/vas`
        case NavigationTypes.DATA_ENTRY_CHECKOUT:
          return `/data-entry-checkout/${params?.initiativeLogicId}/${params?.catalogGroupProductLogicId}`
        case NavigationTypes.THANKYOU_PAGE:
          return `/thankyoupage`
        case NavigationTypes.SUBSCRIPTION_DETAILS:
        return `/profile/subscriptionDetails`
        case NavigationTypes.FINALIZATION_EXTRA:
            return `/finalization-extra`

        /**
         * PDA History pages
         */
        case NavigationTypes.HISTORY_PDA:
            return '/profile/pda/history'
        case NavigationTypes.HISTORY_PDA_DETAILS:
            return `/profile/pda/history/${params?.logicId}`

        default:
            return type
    }
}

export function imageBaseUrl(host: string, loginInfo: any, name?: string) {
    if (name?.startsWith('http') || name?.startsWith('blob') || name?.startsWith('//')) return name;
    const fileNameArray = name?.split('/');
    if(fileNameArray && fileNameArray?.length >= 0){
        const fileName = fileNameArray[fileNameArray.length - 1];
        if(fileName.startsWith('shared_')) return host + '/assets' + (name ? ('/' + name) : '');
        if(fileName.startsWith('tenant_')) return host + '/' + loginInfo?.tenant + '/assets' + (name ? ('/' + name) : '');
    }
    return host + '/' + loginInfo?.tenant + '/' + loginInfo?.project + '/assets' + (name ? ('/' + name) : '');
}

export function imageProviderBaseUrl(host?: string, loginInfo?: any, name?: string) {
    let provider: any = {};
    if (name?.startsWith('http') || name?.startsWith('blob') || name?.startsWith('//')) return name;
    provider.shared = host + '/assets' + (name ? ('/' + name) : '');
    provider.tenant = host + '/' + loginInfo?.tenant + '/assets' + (name ? ('/' + name) : '');
    provider.default = host + '/' + loginInfo?.tenant + '/' + loginInfo?.project + '/assets' + (name ? ('/' + name) : '');
    return provider;
}